import React from "react";
import { Button, Rating } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys, updateResource } from "@/src/services/reactQuery/reactQueryService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { CustomerFeedback } from "@/src/types/Entities/CustomerFeedback";
import ProductBox from "@/src/components/ProductBox/ProductBox";
import CustomerRatingPlatformPrompt from "@/src/components/Feedback/CustomerRatingPlatformPrompt";

type CustomerFeedbackRatingPlatformBoxProps = {
  customerFeedback: CustomerFeedback;
  product: AbstractCase;
};

export default function CustomerFeedbackRatingPlatformBox({ customerFeedback, product }: CustomerFeedbackRatingPlatformBoxProps) {
  const updateMutation = useMutation({ mutationFn: updateResource });
  const queryClient = useQueryClient();

  const hideBox = async () => {
    await updateMutation.mutateAsync({
      uri: "/customer_feedbacks",
      id: customerFeedback.id,
      data: { showProvenExpertRatingRequest: false },
    });

    await queryClient.invalidateQueries({
      queryKey: queryKeys.collection("/customer_feedbacks", {
        source: "fullReview",
        case: `/abstract_cases/${product.id}`,
      }),
    });
  };

  return (
    <ProductBox headline="Danke für Ihre Bewertung!">
      <Rating sx={{ marginBottom: "1rem" }} name="stars" value={5} size="large" disabled />
      <CustomerRatingPlatformPrompt
        customerFeedback={customerFeedback}
        onRatingPlatformClick={hideBox}
        secondaryAction={
          <Button onClick={hideBox} fullWidth variant="outlined">
            Nicht bewerten
          </Button>
        }
      />
    </ProductBox>
  );
}
